import { client as request } from "../../api/request";

/**
 * 経費カテゴリ
 */
export interface ExpenseCategory {
  id: string;
  name: string;
  important: boolean;
  // ?? service_idは型に必要か確認する
}

/**
 * 経費カテゴリの一覧を取得する
 */
export async function getExpenseCategories(): Promise<ExpenseCategory[]> {
  const response = await request.get("get_expense_categories.php");
  return response.expense_categories;
}

/**
 * 経費カテゴリを新規作成/更新する (idが空なら新規作成)
 */
export async function saveExpenseCategory(
  newCategory: ExpenseCategory
): Promise<void> {
  const data = new FormData();
  data.append("id", newCategory.id);
  data.append("name", newCategory.name);
  data.append("important", newCategory.important ? "1" : "0");
  await request.post("save_expense_category.php", data);
}

/**
 * idから経費カテゴリを削除する
 */
export async function deleteExpenseCategory(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);
  await request.post("delete_expense_category.php", data);
}

/**
 * idから経費カテゴリを単体で取得する
 */
export async function getExpenseCategory(
  expenseCategoryId: string
): Promise<ExpenseCategory> {
  const response = await request.get("get_expense_category.php", {
    id: expenseCategoryId
  });
  return response;
}
